import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import Loading from './Loading';

const GlobalLoading: React.FC = () => {
  const { isLoading, loadingMessage } = useLoading();

  return <Loading open={isLoading} message={loadingMessage} fullScreen />;
};

export default GlobalLoading;
